/** Microsoft 365 tab: RMM snapshot slugs and display labels. */

export const M365_SNAPSHOT_SLUGS = [
  'onedrive-health',
  'teams-health',
  'sharepoint-sync-health',
]

export const M365_SNAPSHOT_TITLES = {
  'onedrive-health': 'OneDrive',
  'teams-health': 'Microsoft Teams',
  'sharepoint-sync-health': 'SharePoint sync',
}

export const M365_TAB_DESCRIPTION =
  'Client health for OneDrive, Teams, and SharePoint library sync. OneDrive and SharePoint read the signed-in user profile; schedule those scripts to run as the logged-on user when possible.'

export function m365SnapshotTitle(slug, apiTitle) {
  return apiTitle || M365_SNAPSHOT_TITLES[slug] || slug
}

export function snapshotByM365Slug(snapshots, slug) {
  return (snapshots ?? []).find((s) => s.script_slug === slug) ?? null
}
